<script setup lang="ts">
import { STATE_CONTENT_ADDRESS_SYSTEM } from '@/constants/statesOfAddressSystem'

import { useAddressSystemStateStore } from '@/store/addressSystem'

const { dialogContent } = storeToRefs(useAddressSystemStateStore())

const listTitles = {
  DELIVERY_SELECT: {
    title: 'Способ получения заказа',
    description:
      'После смены адреса состав корзины может измениться: не все товары доступны в других районах или городах',
  },
  ALL_DELIVERY_METHODS: {
    title: 'Способ получения заказа',
    description:
      'После смены адреса состав корзины может измениться: не все товары доступны в других районах или городах.',
  },
  ONLY_DELIVERY: {
    title: 'Доступна только доставка',
    description:
      'Самовывоз и залы недоступны, но можно оформить доставку. Укажите адрес для расчета. Это может изменить корзину и ассортимент.',
  },
}

type Props = {
  isCheckPickup: boolean
  isCheckHall: boolean
}

const props = defineProps<Props>()

// Текущее состояния заголовка с описанием в зависимости от способов доставки
const currentHeadline = computed(() => {
  const { isCheckPickup, isCheckHall } = props

  if (dialogContent.value === STATE_CONTENT_ADDRESS_SYSTEM.SELECT)
    return listTitles.DELIVERY_SELECT

  if (!isCheckPickup && !isCheckHall) return listTitles.ONLY_DELIVERY
  else return listTitles.ALL_DELIVERY_METHODS
})

const classList = computed(() => {
  const list = ['address-system-headline']

  if (dialogContent.value !== STATE_CONTENT_ADDRESS_SYSTEM.SELECT) {
    list.push('address-system-headline--new')
  }

  return list
})
</script>

<template>
  <div :class="classList">
    <div class="address-system-headline__title">
      {{ currentHeadline.title }}
    </div>
    <span class="address-system-headline__description">
      {{ currentHeadline.description }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.address-system-headline {
  &__title {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
    color: var(--ui-text-primary);

    @include media('>tablet') {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__description {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 20px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: var(--ui-color-yellow);
    text-align: center;
    background-color: var(--ui-color-yellow-light);
    border-radius: 12px;

    @include media('>tablet') {
      padding: 8px 40px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &--new {
    .address-system-headline__description {
      @include media('>tablet') {
        padding: 0;
        text-align: left;
        background-color: unset;
      }
    }
  }
}
</style>
